<template>
  <div class="lxn-w100 lxn-h100">
    <div style="height: 4px;"></div>
    <div @click="refresh()" class="TemperatureWidget-wrapper-lcd lxn-margin-auto lxn-border-round lxn-cursor-pointer">
      <div class="TemperatureWidget-wrapper-icon lxn-float-left lxn-h100">
        <ButtonIcon :size="35" bgColor="#52636b" icon="temperature" :iconColor="widgetColor" :padding="0" />
      </div>
      <div class="TemperatureWidget-wrapper-temperature lxn-float-left lxn-h100 lxn-pos-rel">
        <div class="TemperatureWidget-fullDigit lxn-w100 lxn-text-center lxn-text-7seg lxn-pos-abs">
          88
        </div>
        <div class="TemperatureWidget-temperature lxn-w100 lxn-text-center lxn-text-7seg lxn-pos-abs">
          {{temperatureText}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ButtonIcon from '@/components/ButtonIcon.vue'
import NODE6 from '@/statics/devices/Node6/header.js'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'TemperatureWidget',
  props: {
    index: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
      switchLocked: false,
      switchStatus: 0,
    }
  },
  computed: {
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[1];
      }
    },
    node: function () {
      if(this.index != -1){
        return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
      }else{
        return null;
      }
    },
    hub: function () {
      if(this.index != -1){
        return this.$store.getters.getHubByUUID(this.widget.hubUUID);
      }else{
        return null;
      }
    },
    input: function () {
      if(this.index != -1){
        return this.node.inputs[this.widget.settings.inputIndex];
      }else{
        return null;
      }
    },
    isNodeOffline: function () {
      if(this.index != -1){
        if(this.node.connectionStatus == 1){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    isHubOffline: function () {
      if(this.index != -1){
        if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    temperatureText: function () {
      if(this.index != -1){
        var targetParameterId = NODE6.INPUT1.PARAMETER_ID;
        var temperature = this.$store.getters.getParameterValue(this.node.index, targetParameterId);
        if(temperature == undefined){
          return "--";
        }else{
          return Math.floor(temperature/10);
        }
      }else{
        return "24";
      }
    },
  },
  methods: {
    refresh: function () {
      if(this.index == -1){
        return;
      }
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: false,
      });
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid})
      .then( response => {
        this.$store.dispatch('processNodeParameters', {rawParameters: response.body.bodyContent.parameterList, nodeUUID: this.node.uuid});
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }else{
          alert(this.$store.getters.language.texts.TemperatureWidget_alert1);
        }
      })
      .finally( () => {
        this.$store.commit('setAppBusy', false);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
      });
    },
  },
}
</script>

<style>
  .TemperatureWidget-wrapper-lcd {
    width: 100px;
    height: 60px;
    background-color: #52636b;
    border-style: solid;
    border-width: 4px;
    border-color: #c8c9cb;
  }
  .TemperatureWidget-wrapper-icon {
    padding-top: 7px;
    width: 30%;
  }
  .TemperatureWidget-wrapper-temperature {
    width: 70%;
  }
  .TemperatureWidget-fullDigit {
    top: 0;
    left: 0;
    line-height: 52px;
    color: #6e7c85;
    font-size: 35px;
  }
  .TemperatureWidget-temperature {
    top: 0;
    left: 0;
    line-height: 52px;
    color: #a1d0ec;
    font-size: 35px;
  }
</style>
